<template>
  <div class="scheduleDetail_matchPanel">
    <div class="matchPanel_sportsHall">
      <i class="sportsHall_icon"></i>
      <span class="sportsHall_name" v-text="matchInfor.venueName"></span>
    </div>
    <div class="teamArea">
      <span class="teamArea_left">
        <span class="teamArea_teamName" v-text="matchInfor.homeName"></span>
        <span class="teamArea_teamLogo">
          <img v-if="matchInfor.homeLogo" :src="matchInfor.homeLogo" />
        </span>
      </span>
      <span class="teamArea_center">
        <span class="teamArea_homeScore">
          <NumberScrolling
            :tarVal="matchInfor.homeScore"
            :unit="
              matchInfor.homePoint === null ? '' : `(${matchInfor.homePoint})`
            "
          ></NumberScrolling>
        </span>
        <span class="teamArea_maohao">:</span>
        <span class="teamArea_awayScore">
          <NumberScrolling
            :tarVal="matchInfor.awayScore"
            :unit="
              matchInfor.awayPoint === null ? '' : `(${matchInfor.awayPoint})`
            "
          ></NumberScrolling>
        </span>
      </span>
      <span class="teamArea_right">
        <span class="teamArea_teamLogo">
          <img v-if="matchInfor.awayLogo" :src="matchInfor.awayLogo" />
        </span>
        <span class="teamArea_teamName" v-text="matchInfor.awayName"></span>
      </span>
    </div>
    <div class="matchArea">
      <div class="matchArea_absArea">
        <i class="unquoteClass"></i>
        <div class="matchArea_teamLogo">
          <img v-if="matchInfor.homeLogo" :src="matchInfor.homeLogo" />
          <div v-else></div>
          <img v-if="matchInfor.awayLogo" :src="matchInfor.awayLogo" />
          <div v-else></div>
        </div>
        <div class="matchArea_matchEvent">
          <template v-for="eventItem in matchEventList">
            <div
              class="matchEvent_item"
              :key="eventItem.eventId"
              v-if="eventItem.eventType"
              :class="[
                eventItem.eventType,
                eventItem.homeAway,
                eventItem.isShowTip ? 'showTip' : '',
              ]"
              :style="{
                left: `${eventItem.timePer}%`,
              }"
              @click="showTipBtn(eventItem)"
            >
              <span class="matchEvent_text">
                <span class="matchEvent_text_icon"></span>
                <span
                  class="matchEvent_text_infor"
                  v-text="eventItem.name"
                ></span>
              </span>
              <span class="matchEvent_icon" v-text="eventItem.timeText"></span>
            </div>
          </template>
          <!-- <div class="matchEvent_item redCardEvent">
            <span class="matchEvent_text">
              <span class="matchEvent_text_icon"></span>
              <span class="matchEvent_text_infor">141asdawdaw</span>
            </span>
            <span class="matchEvent_icon">104′</span>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import cup_base_data_mixin from '@mixins/cup_base_data'
import NumberScrolling from '@components/compreSportsMeet/html/components/NumberScrolling'
export default {
  name: 'scheduleDetail_matchPanel',
  components: {
    NumberScrolling,
  },
  mixins: [cup_base_data_mixin],
  props: {
    matchInfor: {
      type: Object,
      default: () => ({
        matchStatus: '',
        homeId: '',
        homeName: '',
        homeScore: '-',
        homePoint: null,
        homeLogo: '',
        awayId: '',
        awayName: '',
        awayScore: '-',
        awayPoint: null,
        awayLogo: '',
        venueId: '',
        venueName: '',
      }),
    },
    matchEventList: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {}
  },
  methods: {
    showTipBtn(item) {
      console.debug('eventItemShowTipClickEvent')
      this.$emit('eventItemShowTipClickEvent', item)
    },
  },
}
</script>

<style lang="scss" scoped>
.scheduleDetail_matchPanel {
  height: 20.833vw;
  width: 100%;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .matchPanel_sportsHall {
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    height: 1.388vw;
    .sportsHall_icon {
      width: 1.25vw;
      height: 1.25vw;
      background-image: var(--mixtmt_scheduleMatchList_sportHall_icon);
      background-position: center;
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .sportsHall_name {
      font-size: 0.972vw;
      padding-left: 0.25vw;
    }
  }
  .teamArea {
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    height: 6.25vw;
    width: 100%;
    padding-top: 1.388vw;
    .teamArea_left,
    .teamArea_right {
      flex: 1;
      display: flex;
      display: -webkit-flex;
      align-items: center;
      .teamArea_teamName {
        font-size: 2.083vw;
        color: var(--mixtmt_whiteColor);
        font-weight: bold;
      }
      .teamArea_teamLogo {
        width: 4.86vw;
        height: 4.86vw;
        padding: 0.3vw;
        background-color: var(--mixtmt_greyColor9);
        display: block;
        overflow: hidden;
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: contain;
          /* background-color: red; */
        }
      }
    }
    .teamArea_left {
      justify-content: flex-end;
      .teamArea_teamName {
        padding-right: 1.388vw;
        text-align: right;
      }
    }
    .teamArea_right {
      justify-content: flex-start;
      .teamArea_teamName {
        padding-left: 1.388vw;
        text-align: left;
      }
    }
    .teamArea_center {
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      width: 14.5vw;
      font-size: 2.778vw;
      font-weight: bold;
      color: var(--mixtmt_whiteColor);
      .teamArea_homeScore,
      .teamArea_awayScore {
        width: 5vw;
      }
      .teamArea_homeScore {
        text-align: right;
      }
      .teamArea_maohao {
        width: 1.25vw;
        text-align: center;
      }
    }
  }
  .matchArea {
    width: 100%;
    height: 9vw;
    padding: 0 5.56vw;
    .matchArea_absArea {
      position: relative;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      height: 9vw;
      i.unquoteClass {
        position: absolute;
        top: 50%;
        left: 0;
        z-index: 2;
        transform: translateY(-50%);
        width: 100%;
        height: 2px;
        border-radius: 1px;
        background-color: var(--mixtmt_mainColor8);
        margin-left: 0.9vw;
      }
      .matchArea_teamLogo {
        display: flex;
        display: -webkit-flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: column;
        width: 1.8vw;
        height: 3.6vw;

        img {
          display: block;
          height: calc(1.8vw - 1px);
          width: calc(1.8vw - 1px);
          overflow: hidden;
          object-fit: contain;
        }
        & > div {
          width: calc(1.8vw - 1px);
          height: calc(1.8vw - 1px);
          background-color: var(--mixtmt_greyColor9);
        }
      }
      .matchArea_matchEvent {
        position: relative;
        width: calc(100% - 1.8vw);
        height: 3.6vw;
        .matchEvent_item {
          position: absolute;
          top: 50%;
          left: 0;
          z-index: 5;
          width: auto;
          height: auto;
          transform: translateY(-50%);
          display: flex;
          display: -webkit-flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: center;
          color: var(--mixtmt_whiteColor);
          &.AWAY {
            flex-direction: column-reverse;
            /* margin-top: 0.9vw; */
            /* .matchEvent_text {
              margin-top: 0;
            } */
          }
          &.goalEvent {
            .matchEvent_icon {
              background: linear-gradient(
                180deg,
                var(--mixtmt_scheduleDetailEventColor1_1) 0%,
                var(--mixtmt_scheduleDetailEventColor1_2) 100%
              );
            }
            .matchEvent_text {
              .matchEvent_text_icon {
                background-image: var(--mixtmt_goal_icon);
              }
            }
          }
          &.ownGoalEvent {
            .matchEvent_icon {
              background: linear-gradient(
                180deg,
                var(--mixtmt_scheduleDetailEventColor1_1) 0%,
                var(--mixtmt_scheduleDetailEventColor1_2) 100%
              );
            }
            .matchEvent_text {
              .matchEvent_text_icon {
                background-image: var(--mixtmt_ownGoal_icon);
              }
            }
          }
          &.pointIntoEvent {
            .matchEvent_icon {
              background: linear-gradient(
                180deg,
                var(--mixtmt_scheduleDetailEventColor1_1) 0%,
                var(--mixtmt_scheduleDetailEventColor1_2) 100%
              );
            }
            .matchEvent_text {
              .matchEvent_text_icon {
                background-image: var(--mixtmt_pointInto_icon);
              }
            }
          }
          &.yellowCardEvent {
            .matchEvent_icon {
              background: linear-gradient(
                180deg,
                var(--mixtmt_scheduleDetailEventColor2_1) 0%,
                var(--mixtmt_scheduleDetailEventColor2_2) 100%
              );
            }
            .matchEvent_text {
              .matchEvent_text_icon {
                background-image: var(--mixtmt_yellowCard_icon);
              }
            }
          }
          &.redCardEvent {
            .matchEvent_icon {
              background: linear-gradient(
                180deg,
                var(--mixtmt_scheduleDetailEventColor3_1) 0%,
                var(--mixtmt_scheduleDetailEventColor3_2) 100%
              );
            }
            .matchEvent_text {
              .matchEvent_text_icon {
                background-image: var(--mixtmt_redCard_icon);
              }
            }
          }
          &.endEvent {
            z-index: 4;
            .matchEvent_icon {
              background: linear-gradient(
                180deg,
                var(--mixtmt_scheduleDetailEventColorEnd_1) 0%,
                var(--mixtmt_scheduleDetailEventColorEnd_2) 100%
              );
            }
          }
          /* transform-origin: 0 50%; */
          .matchEvent_icon {
            border-radius: 50%;
            width: 2.08vw;
            height: 2.08vw;
            text-align: center;
            font-size: 0.972vw;
            line-height: 2.08vw;
          }
          .matchEvent_text {
            display: none;
            position: relative;
            margin-top: -1.8vw;
            width: 100%;
            height: 1.8vw;
            transform: translateX(-50%);
            .matchEvent_text_icon {
              display: block;
              position: absolute;
              left: 0;
              top: 0.414vw;
              z-index: 10;
              height: 0.972vw;
              width: 0.972vw;
              background-repeat: no-repeat;
              background-size: 100% auto;
              background-position: center;
              object-fit: contain;
            }
            .matchEvent_text_infor {
              display: block;
              position: absolute;
              left: 1.25vw;
              top: 0;
              z-index: 10;
              font-size: 0.972vw;
              height: 1.8vw;
              line-height: 1.8vw;
              white-space: nowrap;
            }
          }
          &.showTip {
            &.AWAY {
              margin-top: 0.9vw;
              .matchEvent_text {
                margin-top: 0;
              }
            }
            .matchEvent_text {
              display: block;
            }
          }
        }
      }
    }
  }
}

.mixtmt_pc .scheduleDetail_matchPanel {
  .matchArea {
    .matchArea_absArea {
      .matchArea_matchEvent {
        .matchEvent_item {
          &:hover {
            cursor: pointer;
            &.AWAY {
              margin-top: 0.9vw;
              .matchEvent_text {
                margin-top: 0;
              }
            }
            .matchEvent_text {
              display: block;
            }
          }
        }
      }
    }
  }
}
</style>
